function callforPrice () {

    
    this.init = function(){
      
      if(this.checkProductPage()){
       
        if(this.productInArray()){
		  if(hide_price){
          	this.hidePrice();
		  }
          if(hide_ajaxaddtocart){
          	this.hideAddtoCart();
          }
          if(display_call_for_price){
          	this.insertCallButton(this.checkProductPage());
          }
          if(display_phone){
            if(phone_no!=''){
          		this.insertPhoneno();
            }
          }
         
          this.getCallforPriceForm();
          this.getProductList();
          
        }
      }
      else{
        this.getCallforPriceForm();
        this.getProductList();
      }
      
      this.setCallForPriceForm();
      this.setSuccessModal();
      var checkCaptch = 0;
    }
    
    this.getCurrentURL = function(){
       return window.location.href;
    }
    this.checkProductPage = function(){
      if(this.getCurrentURL().indexOf('/products') == -1){
       	return false;
      }
      if(this.getCurrentURL().indexOf('/products') != -1){
         var productURL = this.getCurrentURL().split("/products");
         productURL = productURL[1];
         productURL = productURL.replace("/", "");
         if(productURL.indexOf('?') != -1){
         	var productURL = productURL.substr(0, productURL.indexOf('?')); 
         }
         return productURL;
      }
    }
   
    shopUrl = function(){
       return location.protocol+ '//' + location.host;
    }
    
     
    this.isInArray = function(value, array) {
  		return array.indexOf(value) > -1;
	}
    this.getProductHandle = function(){
        return this.checkProductPage();
    }
    this.productInArray = function(){      
      if (typeof handle_array !== 'undefined' && handle_array.length > 0) {
      	return this.isInArray(decodeURI(this.getProductHandle()), handle_array); // true
      }
    }
    
    this.hidePrice = function(){
        var priceEle =  this.priceContainerElement();
       	var mainContainer = this.productContainerElement();
    	var formContainer = jQuery(mainContainer).find('form[action="/cart/add"]').eq(0);
		if(formContainer.length){
           if(!formContainer.find('.cfpnumber').length){
             //console.log("formContainer.parent().find(priceEle).length " + formContainer.parent().find(priceEle).length);
             if(formContainer.parent().find(priceEle).length){
          			formContainer.parent().find(priceEle).remove();
             }else{
             		formContainer.closest().find(priceEle).remove();
             }
           }
        }
      
    }
    
    this.hideAddtoCart = function(){
        var cartString = this.addtocartContainerElement();
        var mainContainer = this.productContainerElement();
    	var formContainer = jQuery(mainContainer).find('form[action="/cart/add"]').eq(0);
		if(formContainer.length){
          if(!formContainer.find('.cwsCallforPrice').length){
          	formContainer.find('button, input[type="submit"], input[type="button"]').remove();
            if(formContainer.parent().find(cartString).length){
           		formContainer.find(cartString).remove();
            }else{
              formContainer.find(cartString).remove();
            }
          }
        }
      
      
    }
    
    
    this.insertPhoneno = function(){
      var mainContainer = this.productContainerElement();
      var formContainer = jQuery(mainContainer).find('form[action="/cart/add"]').eq(0);
      
      if(formContainer.length){
        if(!enable_outofstock){
          var page_content = jQuery(mainContainer).clone().find("script,noscript,style").remove().end().html();
          
          if(page_content.indexOf('Sold out')==-1){
            var cartButton = jQuery(formContainer).find('button, input[type="submit"], input[type="button"]');
            if(cartButton.attr('disabled')!='disabled'){
			  if(!jQuery('.cfpnumber').length){
              	formContainer.append( jQuery( "<span class='cfpnumber'>"+phone_no_label+"<a href='tel:"+phone_no+"' target='_blank'>"+phone_no+"</a></span>" ) );
			  }
			}
          }
				
        }
        else{
			 if(!formContainer.find('.cfpnumber').length){
              formContainer.append( jQuery( "<span class='cfpnumber'>"+phone_no_label+"<a href='tel:"+phone_no+"' target='_blank'>"+phone_no+"</a></span>" ) );
			}
		}
      }
    }
    
    this.insertCallButton = function(url){
        var mainContainer = this.productContainerElement();
    	var formContainer = jQuery(mainContainer).find('form[action="/cart/add"]').eq(0);
		if(formContainer.length){
          	var url1 = '"'+url+'"';
         	if(!enable_outofstock){
              var page_content = jQuery(mainContainer).clone().find("script,noscript,style").remove().end().html();
             
              
              //ADDED CODE BY ASAD HERE
              //2 Cases: 1. SIMPLE PRODUCT 2. VARAIANT PRODUCT.

              //CASE-1: SIMPLE PRODUCT [NO VARIANTS]
              if(window.variant_prd == "no") 
              {
                	 //Get Product Available Status.
        			 var prd_response = jQuery.parseJSON(
          					jQuery.ajax({
        						url: '/products/'+window.prd_handle+'.js',
        						dataType: "json", 
        						async: false
   	 						}).responseText); 
                  
                	var prd_available = prd_response.available;
                	
                	//INSERT CALL FOR PRICE BTN ONLY IF PRODUCT IS AVAILABLE.
                 
                	if(prd_available == true) {
                      
               			var cartButton = jQuery(formContainer).find('button, input[type="submit"], input[type="button"]');
            			
						if(!jQuery('.cwsCallforPrice').length){
                     	formContainer.append(jQuery("<div class='cwsCallforPrice btn' onclick='showCallForPriceModal(event,"+url1+")' style='"+css_style_button+"'><span class='callPriceText'>"+call_for_price_label+"<span></div>"))
						}
                	}
              }
              else
              {
                //CASE-2: VARAINTS PRODUCT.
                /***
                HERE- INSERT CALL FOR PRICE BTN THEN IN MODAL POPUP, WE'll CHECK THAT WHEN USER CHOOSE VARIANT
                FROM DROPDOWN THEN IF ANY VARIANT IS OUT OF STOCK THEN DISABLE "SUBMIT" BUTTON 
				AND ALSO SHOWS MESSAGE THAT VARIANT IS SOLDOUT OR SELECTED VARIANT COMBINATION IS UNAVAILABLE.
                ***/
                var cartButton = jQuery(formContainer).find('button, input[type="submit"], input[type="button"]');
            			 
				if(!jQuery('.cwsCallforPrice').length){
                 
                formContainer.append(jQuery("<div class='cwsCallforPrice btn' onclick='showCallForPriceModal(event,"+url1+")' style='"+css_style_button+"'><span class='callPriceText'>"+call_for_price_label+"<span></div>"))
				}
              }
              //ENDED HERE
            }
          	else{
            
				if(!formContainer.find('.cwsCallforPrice').length){
          			formContainer.append(jQuery("<div class='cwsCallforPrice btn' onclick='showCallForPriceModal(event,"+url1+")' style='"+css_style_button+"'><span class='callPriceText'>"+call_for_price_label+"<span></div>"))
				}
			}
        }
    }
    
    
   
    checkProductPageforVariantSelection = function(){
      var currenturl = window.location.href;
      if(currenturl.indexOf('/products') == -1){
       	return false;
      }
      if(currenturl.indexOf('/products') != -1){
         var productURL = currenturl.split("/products");
         productURL = productURL[1];
         productURL = productURL.replace("/", "");
         if(productURL.indexOf('?') != -1){
         	var productURL = productURL.substr(0, productURL.indexOf('?')); 
         }
         return productURL;
      }
    }
	
	showCallForPriceModal = function(event,handle_url){
		
	  var product_detail_page_flag = (checkProductPageforVariantSelection() == handle_url);
      var form = jQuery('#cwsCallforPriceModal').find('form#cwsCallforPriceForm');
	  
      jQuery('.cwsCloseForm').click(function(){
         jQuery('#cwsCallforPriceModal').hide();
         jQuery('#cwsCallforSuccessMsg').hide();
      });
      
      //Product Variant
      jQuery('.cwsCfpLoading').show();
      var url = "https://www.callforpriceshp.capacitywebservices.com/call_for_price/ajax/getProductVariant.php?action=getProduct&domain="+shopDomain+"&handle="+handle_url+"";
      jQuery.ajax({
    	url: url,
      	type: "GET",
        //data: jQuery('form#cwsCallforPriceForm').serialize(),
        dataType: 'jsonp'
       }).done(function(product){ 
        jQuery('.cwsCfpLoading').hide();
    	jQuery("#cwsCfpOption").remove(); // Added by Asad to fix the issue of product options showing even for the simple product in call for price modal form once variant product's cfp btn clicked.
        
        if(product.title){
          jQuery('#cwsCallforPriceModal .modal-header').find('h2').html('');
          var newh2 = contact_form_heading+' '+product.title;
          jQuery('#cwsCallforPriceModal .modal-header').find('h2').html(newh2);
 
        }
        if(product.option.length>=1){

          for(var i = 0;i<product.option.length;i++){
            if(i==0){
              var container = jQuery("<div id='cwsCfpOption'></div>");
            }
            if(product.option[i]['name']!='Title'){
            if(jQuery("#cwsCfpOption").length){
              jQuery("#cwsCfpOption").remove();
            }
            
            
            //console.log(product.option[i]['id']);
            container.append("<label for="+product.option[i]['id']+">"+product.option[i]['name']+"</label>");
				
            //var select =  jQuery("<select data-index='option-"+i+"' id='cfpOption_"+product.option[i]['id']+"'></select>");
			var select =  jQuery("<select data-index='option-"+i+"' name='option-"+product.option[i]['name']+"' id='cfpOption_"+product.option[i]['id']+"'></select>");

            container.append(select);
            
			   jQuery.each(product.option[i]['values'], function(text, key) { 

						if(jQuery("select[id^='SingleOptionSelector-"+i+"']").val()==key){
						  var option = new Option(key, key,true,true);

						}else{
							var option = new Option(key, key);
						}
						select.append(jQuery(option)); 

			});
           
          }
          }
          
          
          if(product.html.length){
          
           var select2 =  jQuery("<select name='selectvariant' id='cfpvariant' style='display:none'></select>");
           container.append(select2);

            for(var j =0;j<product.html.length;j++){
              if(product.html[j]['title']!='Default Title'){
                //console.log(product.html[j]['title']);
                if(product.html[j]['inventory_quantity']==0){
                	select2.append('<option disabled="disabled" value="' + product.html[j]['id'] + '">' + product.html[j]['title'] + '</option>');
                  
                }
                else{
                	select2.append('<option value="' + product.html[j]['id'] + '">' + product.html[j]['title'] + '</option>');
              
                }
              }
            }
           
            if(form.find('#cwsCFPcaptcha').length){
            	jQuery( container ).insertBefore( "#cwsCFPcaptcha" );
            }
            else{
                jQuery( container ).insertBefore( "#cwsCFPsubmit" );
            }
          }
         
        }
         
        if(enabled_captcha==0 || site_key==''){
         	form.find('#cwsCFPcaptcha').remove();
        }
        else{
          jQuery('#cwsCFPsubmit').prop("disabled", true);
          if(form.find('#cwsCFPcaptcha').length){
            form.find('#cwsCFPcaptcha').remove();
          }
          jQuery('<div id="cwsCFPcaptcha"></div>').insertBefore( "#cwsCFPsubmit" );
          loadCaptcha();
        }
        if(form.find('input[name=productHandle]').length){
        	form.find('input[name=productHandle]').remove();
        }
      	form.append("<input type='hidden' value='"+handle_url+"' id='productHandle' name='productHandle'/>");
        jQuery('#cwsCFPsubmit').val(submit_label); // Modified by Asad to fix the submit_label issue.
      	jQuery('#cwsCallforPriceModal').show();
        
        if(product.option.length>=1){
        	checkVariant();
          	checkfirstSelected();
        }
        
       }).fail(function(error){
      
       });
      
      // End
      
      
      
      
      event.preventDefault();
      return false;
    }
    loadCaptcha = function(){
      var actCallback = function (response) {
        
        jQuery('#cwsCFPsubmit').prop("disabled", false);
        checkfirstSelected();
        checkCaptch = 1;
      };
      var expCallback = function() {
      
        jQuery('#cwsCFPsubmit').prop("disabled", true);
      };
      var widget = grecaptcha.render(document.getElementById("cwsCFPcaptcha"), {
          'sitekey' : site_key, // Sitekey, Retrieving from reCaptcha
          'theme': "light",
          'callback' : actCallback,
          'expired-callback': expCallback,
      });
    
    }
    checkfirstSelected = function(){
      if(jQuery("*[id^='cfpOption_']").length){
      var selectstr = '';
      var selectOptionstart = new Array();
      jQuery("*[id^='cfpOption_']").each(function(){
         selectOptionstart.push(jQuery(this).val());
      });
     
      var selectstr = selectOptionstart.join(" / ");
      var cntStart=0;
       jQuery("#cfpvariant > option").each(function(e) {
              
               if(jQuery.trim(this.text) === jQuery.trim(selectstr)){
                   cntStart = parseInt(cntStart)+1;
               }
		});
      
      	if(cntStart!=0){
         
        }
        else{
          
          jQuery('#cwsCFPsubmit').prop("disabled",true);
          jQuery('#cwsCFPsubmit').val(unavailable_label); // Added by Asad to give dynamic unavailable button text.
        }
    }
    }
    checkVariant = function(){
      var total = jQuery("*[id^='cfpOption_']").length;
     
        jQuery("*[id^='cfpOption_']").change(function(){
          
           var data_index = jQuery(this).attr('data-index');
           var selVal = jQuery(this).val();
           var number = data_index.substr(data_index.indexOf("-") + 1);
           var str = '';
         
           var selectOption = new Array();
           jQuery("*[id^='cfpOption_']").each(function( index ) {
               selectOption.push(jQuery(this).val());
           });
           var str = selectOption.join(" / ");
          
           var cnt=0;
           jQuery("#cfpvariant > option").each(function(e) {
              	
               if(jQuery.trim(this.text) === jQuery.trim(str)){
                               
                   cnt = parseInt(cnt)+1;
                
                
                
               }
		   });
          if(cnt!=0){
            if(enabled_captcha==0 || site_key==''){
                jQuery('#cwsCFPsubmit').prop("disabled", false);
                jQuery('#cwsCFPsubmit').val(submit_label); // Modified by Asad to fix submit_label issue
            }
            else{
               if(typeof checkCaptch == 'undefined' || checkCaptch == null){
               
            	jQuery('#cwsCFPsubmit').prop("disabled", true);
                 jQuery('#cwsCFPsubmit').val(submit_label); // Modified by Asad to fix submit_label issue
               }
              else{
                jQuery('#cwsCFPsubmit').prop("disabled", false);
                 jQuery('#cwsCFPsubmit').val(submit_label); // Modified by Asad to fix submit_label issue
              }
            }
            
          }
          else{
            jQuery('#cwsCFPsubmit').prop("disabled",true);
            jQuery('#cwsCFPsubmit').val(unavailable_label); // Added by Asad to give dynamic unavailable button text.
          }
        });
    }
    this.getCallforPriceForm = function(){
     // grecaptcha.reset();
      var time = new Date().getTime();
      var url = "https://www.callforpriceshp.capacitywebservices.com/call_for_price/templates/callforPriceForm.php";
      
         	 jQuery('.cwsCloseForm').click(function () {
         		jQuery('#cwsCallforPriceModal').hide();
                jQuery('#cwsCallforSuccessMsg').hide();
        	 });
       		
			jQuery('#cwsCallforPriceForm #cwsCFPsubmit').click(function (event) {
           		event.preventDefault();
                event.stopImmediatePropagation();
              	var name = jQuery('#cwsCallforPriceForm #cname').val();
             	var email = jQuery('#cwsCallforPriceForm #cemail').val();
              	var comment = jQuery('#cwsCallforPriceForm #comment').val();
              	var phone = jQuery('#cwsCallforPriceForm #phone').val();
                jQuery(".cwsModalerror_show").remove();
              	if (name.length < 1) {
                  if(required_field!=''){
                    if(required_field.indexOf('name') !== -1){
                     jQuery('#cwsCallforPriceForm #cname').after('<span class="cwsModalerror_show">'+error_name_label+'</span>');
                    }
                  }
    			}
                if(comment.length < 1){
                  if(required_field!=''){
                    if(required_field.indexOf('comment') !== -1){
                  		jQuery('#cwsCallforPriceForm #comment').after('<span class="cwsModalerror_show">'+error_comment_label+'</span>');
                    }
                  }
                }
                if(email.length < 1){
                 		 jQuery('#cwsCallforPriceForm #cemail').after('<span class="cwsModalerror_show">'+error_email_label+'</span>');
                }
              	else {
      				var regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      				var validEmail = regEx.test(email);
      				if (!validEmail) {
        				$('#cwsCallforPriceForm #cemail').after('<span class="cwsModalerror_show">'+error_email_label+'</span>');
      				}
   				}
                if(phone.length<1){
              	 if(required_field!=''){
                    if(required_field.indexOf('phone') !== -1){
        				$('#cwsCallforPriceForm #phone').after('<span class="cwsModalerror_show">'+error_phone_label+'</span>');
                    }
                  }
                }
                if(phone.length>0){
              	  //var phoneno = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
				  var phoneno = /^((\+[1-9]{1,4}[ \-]*)|(\([0-9]{2,3}\)[ \-]*)|([0-9]{2,4})[ \-]*)*?[0-9]{3,4}?[ \-]*[0-9]{3,4}?$/;
                  var validPhone = phoneno.test(phone);
      				if (!validPhone) {
        				$('#cwsCallforPriceForm #phone').after('<span class="cwsModalerror_show">'+error_phone_label+'</span>');
      				}
                }
              if(jQuery(".cwsModalerror_show").length=='' || jQuery(".cwsModalerror_show").length==0){
                
               var selectOption = new Array();
               jQuery("*[id^='cfpOption_']").each(function( index ) {
                 selectOption.push(jQuery(this).val());
               });
               var str = selectOption.join(" / ");
                
               str = str.toString();
               jQuery("#cfpvariant > option").each(function() {    				
                 if(jQuery.trim(this.text) === jQuery.trim(str)){
                  	jQuery("#cwsCallforPriceForm #cfpvariant").val(this.value).change();
                  }
			   });
                
               var time = new Date().getTime();
      		   var url = "https://www.callforpriceshp.capacitywebservices.com/call_for_price/ajax/callforPriceForm.php?action=submitCallForPrice&domain="+shopDomain+"&currentTime="+time+"";
      			jQuery('.cwsCfpLoading').show();
                jQuery.ajax({
    	  			url: url,
          			type: "GET",
                    data: jQuery('form#cwsCallforPriceForm').serialize(),
          			dataType: 'jsonp'
    				}).done(function(res){
                     
                      if(res.html == 'true'){
                        jQuery('#cwsCallforPriceModal').hide();
                        jQuery('.cwsCfpLoading').hide();
                        jQuery('#cwsCallforSuccessMsg').show();
                      }
                  	}).fail(function(error){
      
       				});
                } 
                
             });
         	
     
        window.onclick = function(event) {
          var modal = document.getElementById('cwsCallforPriceModal');
            if (event.target == modal) {
                modal.style.display = "none";
            }
           var modal1 = document.getElementById('cwsCallforSuccessMsg');
            if (event.target == modal1) {
                modal1.style.display = "none";
            }
        }
        
    }
    
    
   
    
   this.getProductList = function(){
      var cwsPrice = new callforPrice();
      var product_container = this.productContainerElement();
   	  var price_container = this.priceContainerElement();
      var add_to_cart_container = this.addtocartContainerElement();
     
     
     
      jQuery( "div[class^='cws-callforprice-element']" ).each(function() {
       
        var handle = jQuery(this).attr('data-handle');
        if(handle!=''){
          
          var existHandle = cwsPrice.returnProductUrlInArray(handle);
          var sold = jQuery(this).attr('data-available');
          
          var url1 = '"'+handle+'"';
          if(existHandle){
            /*** If Product is Sold Out ***/
            if(sold=='false'){
                            //enable_outofstock = 1;
              if(enable_outofstock){
                if(display_phone){
                	if(phone_no!=''){
                      if(jQuery(this).find('.cfpnumber').length<=0){
                		jQuery(this).append( jQuery( "<span class='cfpnumber'>"+phone_no_label+"<a href='tel:"+phone_no+"' target='_blank'>"+phone_no+"</a></span>" ) );
                      }
                    }
                }
                if(display_call_for_price){
                   if(jQuery(this).find('.cwsCallforPrice').length<=0){
                		jQuery(this).append(jQuery("<div class='cwsCallforPrice btn' onclick='showCallForPriceModal(event,"+url1+")' style='"+css_style_button+"'><span class='callPriceText'>"+call_for_price_label+"<span></div>"))
                   }
                }
                /*** Check if hide price setting is enabled. If yes, then only remove the price (ADDED BY ASAD) ***/
                if(hide_price)
                {
               		jQuery(this).closest(product_container).find(price_container).remove();
                }
                /*** Check if hide Add to Cart setting is enabled. If yes, then only remove the add to cart button (ADDED BY ASAD) ***/
                if(hide_ajaxaddtocart)
                {
                  	jQuery(this).closest(product_container).find(add_to_cart_container).remove();
                }
              }
            }
            /*** If Product is available ***/
            else{
                if(display_phone){
                	if(phone_no!=''){
                      if(jQuery(this).find('.cfpnumber').length<=0){
                		jQuery(this).append( jQuery( "<span class='cfpnumber'>"+phone_no_label+"<a href='tel:"+phone_no+"' target='_blank'>"+phone_no+"</a></span>" ) );
                        
                      }
                     }
                }
                if(display_call_for_price){
                  if(jQuery(this).find('.cwsCallforPrice').length<=0){
                	jQuery(this).append(jQuery("<div class='cwsCallforPrice btn' onclick='showCallForPriceModal(event,"+url1+")' style='"+css_style_button+"'><span class='callPriceText'>"+call_for_price_label+"<span></div>"))
                  }
                }
              	/*** Check if hide price setting is enabled. If yes, then only remove the price (ADDED BY ASAD) ***/
                if(hide_price)
                {
                	
                  jQuery(this).closest(product_container).find(price_container).remove();
                }
                /*** Check if hide Add to Cart setting is enabled. If yes, then only remove the add to cart button (ADDED BY ASAD) ***/
                if(hide_ajaxaddtocart)
                {
                	jQuery(this).closest(product_container).find(add_to_cart_container).remove();
                }
            }
          }
          else{
            jQuery(this).remove();
          }
        }
      });
      
     
     
     
    }
   	
    this.returnProductLink = function(url){
      if(url.indexOf('/products') != -1){
         var productURL = url.split("/products");
         productURL = productURL[1];
         productURL = productURL.replace("/", "");
		 if(productURL.indexOf('?') != -1){
         	var productURL = productURL.substr(0, productURL.indexOf('?')); 
         }
         return productURL;
      }
 	}
    
    this.returnProductUrlInArray = function(url){
      if (typeof handle_array !== 'undefined' && handle_array.length > 0) {
      	return this.isInArray(decodeURI(url), handle_array); 
      }
    }
    this.setSuccessModal = function(){
     	
      if(thankyou_header != ''){
         jQuery('#cwsCallforSuccessMsg .modal-header').find('h2').html(thankyou_header);
      }
      else{
        jQuery('#cwsCallforSuccessMsg .modal-header').find('h2').html('SucessFull');
      }
      if(thankyou_msg !=''){
           jQuery('#cwsCallforSuccessMsg .modal-body').text(thankyou_msg);
      }
      else{
           jQuery('#cwsCallforSuccessMsg .modal-body').text('Inquiry was sent.');
      }
    }
    this.setCallForPriceForm = function(){
      var formModal = jQuery('#cwsCallforPriceModal');
      if(name_label){
        formModal.find('#cwsCallforPriceForm #cname_label').text(name_label);
      }
      if(email_label){
        formModal.find('#cwsCallforPriceForm #cemail_label').text(email_label);
      }
      if(phone_label){
        formModal.find('#cwsCallforPriceForm #cphone_label').text(phone_label);
      }
      if(comment_label){
        formModal.find('#cwsCallforPriceForm #ccomment_label').text(comment_label);
      }
      if(submit_label){
         formModal.find('#cwsCallforPriceForm #cwsCFPsubmit').attr('value',submit_label);
		 formModal.find('#cwsCallforPriceForm #cwsCFPsubmit').val(submit_label); // Modified by Asad to fix the submit_label issue
      }
    }
    
    
     this.collectionPageCartForm = function(){
      var cartForm = 'form[action="/cart/add"]';
      return cartForm;
    }
    
    
    this.productContainerElement = function(){
       var listString = ['.product-info',
                         'li',
                         'div.grid__item',
                         'div.product',
                         'div.grid-view-item',
                         'div.collection__item',
                         'div.productitem',
                         'div[class*="product-item"]',
                         'article[class*="productgrid"]',
                         'article[class*="card"]',
                         'div.xs-card',
                         'a[href*="/products/"]',
                         '.product-index',
                         '.owl-item',
                         '.isp_grid_result',
                         '.snize-product',
                         '.grid-item',
                         'div.card',
                         '.flickity-viewport .product-wrap',
                         'article, div.related-products a',
                         '.product--wrapper',
                         '.bk-product',
                         '.box.product',
                         '.box_1',
                         '.indiv-product',
                         '.product-index',
                         '.product-car',
                         '.product-card',
                         '.product-wrap',
                         '.product:not(body)',
                         '.products .one-third.column.thumbnail',
                         '.limespot-recommendation-box-item .ls-link',
                         '.mp-product-grid',
                         '.product-grid .four-col .product-link .img-outer',
                         '.collection-matrix .grid__item',
                         '.product-grid .product-item',
                         '.ais-product',
                         '.ProductItem__Wrapper',
                         '.grid-product__content',
                         '.bkt--products-vertical',
                         '.lb-product-wrapper',
                         '.product-link .rimage-outer-wrapper',
                         '.grid__cell .product-item',
                         '.item.large--one-quarter',
                         'div.list-view-item',
                         '.product-recommendations--container',
                         '.recently-viewed-products',
                         '.box-related'];
      
       if(parent_selector != "") {
          parent_selector = parent_selector.replace(/(^,)|(,$)/g, "");
          listString.push(parent_selector);
       }
      
       return listString.toString();
      
    }
    
    
    
    this.priceContainerElement = function(){
       var listString =[".product__prices",
                            ".price-box",
                            "#comparePrice-product-template",
                            "#ProductPrice-product-template",
                            "#ProductPrice",".product-price",
                            ".product__price",
                            "#productPrice-product-template",
                            ".product__current-price",
                            ".product-thumb-caption-price-current",
                            ".product-item-caption-price-current",
                            ".grid-product__price",
                            ".product__price",
                            "span.price",
                            "span.product-price",
                            ".productitem--price",
                            ".product-pricing",
                            "span.money",
                            ".product-item__price",
                            ".product-list-item-price",
                            "p.price",
                        	"div.price",
                            ".product-meta__prices",
                            "div.product-price",
                            "span#price",
                            ".price.money",
                            "h3.price",
                            "a.price",
                            ".price-area",
                            ".product-item-price",
                            ".pricearea",
                            ".collectionGrid .collectionBlock-info > p",
                            "#ComparePrice",
                            ".product--price-wrapper",
                            ".product-page--price-wrapper",
                            ".color--shop-accent.font-size--s.t--meta.f--main",
                            ".ComparePrice",
                            ".ProductPrice",
                            ".prodThumb .title span:last-child",
                            ".price",
                            ".product-single__price-product-template",
                        	".product-info-price",
                            ".price-money",
                            ".prod-price",
                            "#price-field",
                            ".product-grid--price",
                            ".prices",
                            ".pricing",
                            "#product-price",
                            ".money-styling",
                            ".compare-at-price",
                            ".product-item--price",
                            ".card__price",
                            ".product-card__price",
                            ".product-price__price",
                            ".product-item__price-wrapper",
                            ".product-single__price",
                            ".grid-product__price-wrap",
                            "a.grid-link p.grid-link__meta",
                            ".grid-link__meta",
                            ".dualPrice",
                            ".product-item--price",
                            "#productPrice-product-template",
                            ".grid-product__price",
                            ".card__price",
                            ".product-card__price",
                            ".product-item__price-wrapper",
                            ".product__prices",
                            ".product__price",
                            ".price",
                        	".Price",
                            ".pricing",
                            ".Pricing",
                            ".money",
                            ".Money",
                            ".product-price__price",
                            ".product-price",
                            ".product-single__price"];
     
     if(price_selector != "") {
     	price_selector = price_selector.replace(/(^,)|(,$)/g, "");
       	listString.push(price_selector);
     }
      return listString.toString();
      
    }
    
    this.addtocartContainerElement = function(){
       var listString = [".product-form__item--quantity",
                         ".shopify-payment-button__button",
                         ".singleCart",
                         "#AddToCart-product-template",
                         "#AddToCart",
                         "#addToCart-product-template",
                         ".product__add-to-cart-button",
                         ".product-form__cart-submit",
                         ".add-to-cart",
                         ".cart-functions > button",
                         ".productitem--action-atc",
                         ".product-form--atc-button",
                         ".product-menu-button-atc",
                         ".product__add-to-cart",
                         ".product-add",
                         ".add-to-cart-button",
                         "#addToCart",
                         ".product-detail__form__action > button",
                         ".product-form-submit-wrap > input",
                         ".product-form input[type=\"submit\"]",
                         "input.submit",
                         ".add_to_cart",
                         ".product-item-quick-shop",
                         "#add-to-cart",
                         ".productForm-submit",
                         ".add-to-cart-btn",
                         ".product-single__add-btn",
                         ".quick-add--add-button",
                         ".product-page--add-to-cart",
                         ".addToCart",
                         ".product-form .form-actions",
                         ".button.add",
                         ".btn-cart",
                         "button#add",
                         ".addtocart",
                         ".AddtoCart",
                         ".product-add input.add",
                         "button#purchase",
                         "form[action=\"\/cart\/add\"] input[type=\"button\"]",
                         "form[action=\"\/cart\/add\"] button[type=\"button\"]",
                         "form[action=\"\/cart\/add\"] input[type=\"submit\"]",
                         "form[action=\"\/cart\/add\"] button[type=\"submit\"]",
                         ".product__form button[type=\"submit\"]",
                         "#AddToCart--product-template",
                         ".cws_atc_form",
                        ".shopify-payment-button"];

      if(cart_selector!='')
      {
        cart_selector = cart_selector.replace(/(^,)|(,$)/g, "");
        listString.push(cart_selector);
      }
      return listString.toString();
      
    }
}

function initialize_callforprice(){

  jQuery(document).ready(function ($) {


     if(enable_app){
           var cwsPrice = new callforPrice();
           cwsPrice.init();
           jQuery("body").css("opacity", '1');
           jQuery("html").css("opacity", '1');
           var productContainerElements = cwsPrice.productContainerElement();

           var MutationObserver = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;;
           if(typeof MutationObserver === 'function'){
               //  console.log("MutationObserver");
                var timeOut = false;	   
                // Create an observer instance
                var observer = new MutationObserver(function( mutations ) {
                  mutations.forEach(function( mutation ) {

                    var newNodes = mutation.addedNodes; // DOM NodeList

                    if( newNodes !== null ) { // If there are new nodes added
                        var $nodes = $( newNodes ); // jQuery set
                        $nodes.each(function() {
                            var $node = $( this );
                             clearTimeout(timeOut);
                              // do something
                              timeOut = setTimeout(function(){ 
                                if( $node.find(".cws-callforprice-element")) {
                                  cwsPrice.getProductList();
                                }
                              }, 500);
                       });
                    }
                  });    
                });

                // Configuration of the observer:
                var config = { 
                      attributes: false,
                      attributeOldValue: false,
                      characterData: false,
                      characterDataOldValue: false,
                      childList: true,
                      subtree: true

                };

                var targetNode = document.body;	
                // Pass in the target node, as well as the observer options
                observer.observe(targetNode, config);

                // Later, you can stop observing
               // observer.disconnect();

           }else{  // fallback on DOMNodeInserted for browser's not supporting MutationObserver API 
			 //  console.log("DOMNodeInserted");
               var timeOut = false;	  
               jQuery(document).on('DOMNodeInserted',productContainerElements, function(e) {
                 clearTimeout(timeOut); 

                 timeOut = setTimeout(function(){ 
                   if(jQuery(e.target).find(".cws-callforprice-element")){
                      cwsPrice.getProductList();
					}
                 }, 500);

               });

           }
     }else{

          if(jQuery(".cws-callforprice-element".length)){
            jQuery( "div[class^='cws-callforprice-element']" ).remove();
          }
          jQuery("body").css("opacity", '1');
          jQuery("html").css("opacity", '1');

     }

  });

}

if(document.getElementsByTagName("html")[0].style.opacity!=1){
	document.getElementsByTagName("html")[0].style.opacity = 0;
}




function loadScript(url, callback) {
  var script = document.createElement("script")
  script.type = "text/javascript";

  if (script.readyState) { //IE
    script.onreadystatechange = function () {
      if (script.readyState == "loaded" || script.readyState == "complete" || script.readyState == "loading" || dom.readyState == "uninitialized") {
        script.onreadystatechange = null;

        callback();
      }
    };
  } else { //Others

    script.onload = function () {
      callback();

    };
  }


  script.type = 'text/javascript';
  script.async = true;
  script.src = url;
  var x = document.getElementsByTagName('script')[0];
  x.parentNode.insertBefore(script, x);


}

var cws_callforprice_installed = 0;
function checkappinstalled_callforprice(){

  
  var jqscriptobj = jQuery("script");
  if(jqscriptobj.text().indexOf("callforprice_install.js?") != -1 && jqscriptobj.text().indexOf("asyncLoad") != -1 && jqscriptobj.text().indexOf("initSchema") == -1) {
    if(cws_callforprice_installed == 0){
      cws_callforprice_installed = 1;
    }
  }else{
    jQuery("body").css("opacity", '1');
    jQuery("html").css("opacity", '1');
  }
  
  return cws_callforprice_installed;

}



if (typeof jQuery === "undefined") {
  
      loadScript("//code.jquery.com/jquery-3.3.1.min.js", function () {
		
        
        
        jQuery.noConflict();
        cws_callforprice_installed = checkappinstalled_callforprice();
        //console.log("jQuery loaded via loadScript");
        if(cws_callforprice_installed){
            initialize_callforprice();
        }

      });
    
  
}else{
  
   if((jQuery.fn.jquery.replace(/\.(\d)/g,".0$1").replace(/\.0(\d{2})/g,".$1") < "1.08.01")){
    
     //console.log("jQuery loaded  via loadScript else " + jQuery.fn.jquery);
      loadScript("//code.jquery.com/jquery-3.3.1.min.js", function () {
                
        jQuery.noConflict();
        cws_callforprice_installed = checkappinstalled_callforprice();
          if(cws_callforprice_installed){
                  initialize_callforprice();
          }

        });
     
  }else{
     
       cws_callforprice_installed = checkappinstalled_callforprice();

       if(cws_callforprice_installed){
          initialize_callforprice();
        }

      
  }

}
